import React from 'react'
import './Technologies.scss'
import { Link } from 'react-router-dom'
import Php from '../assets/images/technologies/php.png'
import Java from '../assets/images/technologies/java.png'
import Net from '../assets/images/technologies/net.png'
import NodeJS from '../assets/images/technologies/nodejs.png'
import ReactJS from '../assets/images/technologies/reactjs.png'
import AngularJS from '../assets/images/technologies/angular.png'
import Vue from '../assets/images/technologies/vue.png'
import NextJS from '../assets/images/technologies/nextjs.png'
import Joomla from '../assets/images/technologies/joomla.png'
import Android from '../assets/images/technologies/adnroid.png'
import JavaScript from '../assets/images/technologies/java-script.png'
import Ruby from '../assets/images/technologies/ruby-on-rails.png'
import Shopify from '../assets/images/technologies/shopify.png'
import WordPress from '../assets/images/technologies/wordpress.png'
import WooCommerce from '../assets/images/technologies/woocommerce.png'
import Magento from '../assets/images/technologies/magento.png'
import Symfony from '../assets/images/technologies/symfony.png'
import Laravel from '../assets/images/technologies/laravel.png'
import Drupal from '../assets/images/technologies/drupal.png'
import Magnolia from '../assets/images/technologies/magnolia.png'
import HTML5 from '../assets/images/technologies/html.png'
import C from '../assets/images/technologies/c.png'
import Swift from '../assets/images/technologies/swift.png'
import Python from '../assets/images/technologies/python.png'
import iOS from '../assets/images/technologies/ios.png'

const technologiesDataRow1 = [
  { name: "Php", icon: <img src={Php} alt="" /> },
  { name: "Java", icon: <img src={Java} alt="" /> },
  { name: ".NET", icon: <img src={Net} alt="" /> },
  { name: "NodeJS", icon: <img src={NodeJS} alt="" /> },
  { name: "ReactJS", icon: <img src={ReactJS} alt="" /> },
  { name: "AngularJS", icon: <img src={AngularJS} alt="" /> },
  { name: "Vue", icon: <img src={Vue} alt="" /> },
  { name: "NextJS", icon: <img src={NextJS} alt="" /> },
  { name: "Joomla", icon: <img src={Joomla} alt="" /> },
  { name: "Android", icon: <img src={Android} alt="" /> },
  { name: "JavaScript", icon: <img src={JavaScript} alt="" /> },
  { name: "Ruby on Rails", icon: <img src={Ruby} alt="" /> },
  { name: "Shopify", icon: <img src={Shopify} alt="" /> },
  { name: "Wordpress", icon: <img src={WordPress} alt="" /> },
  { name: "WooCommerce", icon: <img src={WooCommerce} alt="" /> },
  { name: "Magento", icon: <img src={Magento} alt="" /> },
  { name: "Symfony", icon: <img src={Symfony} alt="" /> }
]

const technologiesDataRow2 = [
  { name: "Laravel", icon: <img src={Laravel} alt="" /> },
  { name: "Drupal", icon: <img src={Drupal} alt="" /> },
  { name: "Magnolia", icon: <img src={Magnolia} alt="" /> },
  { name: "HTML 5", icon: <img src={HTML5} alt="" /> },
  { name: "C#", icon: <img src={C} alt="" /> },
  { name: "Swift", icon: <img src={Swift} alt="" /> },
  { name: "Python", icon: <img src={Python} alt="" /> },
  { name: "iOS", icon: <img src={iOS} alt="" /> }
];
const duplicateItems = (data, multiplier) => {
  let repeated = [];
  for (let i = 0; i < multiplier; i++) {
    repeated = [...repeated, ...data];
  }
  return repeated
}

const repeatedRow1 = duplicateItems(technologiesDataRow1, 20)
const repeatedRow2 = duplicateItems(technologiesDataRow2, 20)

const Technologies = ({ bckColorClass = '' }) => {
  return (
    <div className="container fade-in">
      <h2 className="section-title">TECHNOLOGIES</h2>
      <div className="section-heading">Our Technology Stack and Platforms
        <div className="section-description">
          TechTonic provides customers with expertise across an extensive array of technologies and platforms.
        </div>
      </div>

      <div className="marquee-container">
        <div className="marquee">
          {repeatedRow1.map((tech, index) => (
            <div key={index} className="technology-card">
              <span className="tech-icon">{tech.icon}</span>
              <span className="tech-name">{tech.name}</span>
            </div>
          ))}
        </div>

        <div className="marquee reverse">
          {repeatedRow2.map((tech, index) => (
            <div key={index} className="technology-card">
              <span className="tech-icon">{tech.icon}</span>
              <span className="tech-name">{tech.name}</span>
            </div>
          ))}
        </div>
      </div>
      <a href="/contact" className="button section-cta">Let’s Talk About Your Business ➔</a>
    </div>
  )
}

export default Technologies;
  
